'use client';

import { c as _c } from "react/compiler-runtime";
import useEmblaCarousel from 'embla-carousel-react';
import { ImageComponent } from '@/components/ui/ImageComponent';
import { careersHeroData } from '../../_data/careers';
export function CareersImageCarousel() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      align: "start",
      loop: false,
      breakpoints: {
        "(min-width: 1024px)": {
          active: false
        }
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative flex-[0_0_85%] min-w-0 lg:flex-auto lg:col-span-8 w-full rounded-[24px] overflow-hidden bg-linear-to-b from-[#E5E5E5] to-[#999] shadow-[0_0_54px_0_rgba(0,0,0,0.02)]"><ImageComponent src={careersHeroData.images[0]} alt="Careers 1" fill={true} className="object-cover" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative flex-1 w-full rounded-[24px] overflow-hidden bg-linear-to-b from-[#E5E5E5] to-[#999] shadow-[0_0_54px_0_rgba(0,0,0,0.02)]"><ImageComponent src={careersHeroData.images[1]} alt="Careers 2" fill={true} className="object-cover" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex lg:grid lg:grid-cols-12 gap-4 lg:gap-6 h-[280px] lg:h-[480px]">{t1}<div className="flex-[0_0_150%] min-w-0 lg:flex-auto lg:col-span-4 flex flex-row lg:flex-col gap-4 lg:gap-6">{t2}<div className="relative flex-1 w-full rounded-[24px] overflow-hidden bg-linear-to-b from-[#E5E5E5] to-[#999] shadow-[0_0_54px_0_rgba(0,0,0,0.02)]"><ImageComponent src={careersHeroData.images[2]} alt="Careers 3" fill={true} className="object-cover" /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== emblaRef) {
    t4 = <div className="mt-10 lg:mt-16 overflow-hidden lg:overflow-visible" ref={emblaRef}>{t3}</div>;
    $[4] = emblaRef;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}